import { Role } from "@hulanbv/ssllow-packages";
import { dictionary } from "./i18n/dictionary";

export const roleLabels: { [key in Role]: string } = {
  [Role.ADMIN]: dictionary.administrator,
  [Role.EXPERT]: dictionary.expert,
  [Role.USER]: dictionary.user,
  [Role.VIEWER]: dictionary.spectator,
};
